<template>
	<div 
		class="pxrwwfgv-screen-description" 
		:class="descClass"
		@click="goNext"
	></div>
</template>
<script setup >
	import {computed} from 'vue';
	import {useStore} from 'vuex';

	const store = useStore();

	const descClass = computed(() => {
		return ['-'+store.getters.selectedVidek];
	});

	function goNext(){
		store.dispatch('setScreen', 'startvideo');
	}
</script>
<style>
	.pxrwwfgv-screen-description {
		width: 100%;
		height: 100%;
		background-position: 50% 50%;
		background-size: cover;
		cursor: pointer;
	}
	.pxrwwfgv-screen-description.-sikvidek {
		background-image: url('@/assets/images/desc_sikvidek.png');
	}
	.pxrwwfgv-screen-description.-dombvidek {
		background-image: url('@/assets/images/desc_dombvidek.png');
	}
</style>